/*
 * @Author: edvardchen
 * @Date: 2018-03-16 15:28:33
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 16:18:28
 */

// @flow
export default (params: string | Object) => {
  try {
    const _p = typeof params === 'string' ? params : JSON.stringify(params);
    if (window.__REACT_WEB_VIEW_BRIDGE && window.__REACT_WEB_VIEW_BRIDGE.postMessage) {
      window.__REACT_WEB_VIEW_BRIDGE.postMessage(_p);
    } else {
      window.postMessage && window.postMessage(_p);
    }
  } catch (e) {
    console.warn('postMessage failed', params, e.message);
  }
};
